export const aboutData = {
    title: "About Me",
    description1: "My name's Virsail. I'm a fullstack software developer and web designer based in Nairobi, Kenya.",
    description2: "I'm skilled in a wide variety of coding niches both server-side and Front end this enables me to provide end to end service.I'm very open to learning new technologies so right now I'm  trying a hand at machine learning and AI",
    image: 2
}